import { IconButton, useTheme } from '@mui/material';
import { Image } from '@realadvisor/image';
import { Trash2Icon } from 'lucide-react';

import type { StepCoverPropertyImageType } from '@modules/reports/shared/CoverPhotoSelector/CoverPhotoSelector';
import SelectableCard from '@modules/reports/shared/CoverPhotoSelector/SelectableCard';

type PropertyImageItemProps = {
  propertyImage: StepCoverPropertyImageType;
  isSelected: boolean;
  onSelect: (selected: boolean) => void;
  onDelete: (imageId: string) => void;
};

const PropertyImageItem = ({
  propertyImage,
  isSelected,
  onSelect,
  onDelete,
}: PropertyImageItemProps) => {
  const theme = useTheme();

  return (
    <div key={propertyImage.id} style={{ position: 'relative' }}>
      <SelectableCard selected={isSelected} onChange={onSelect}>
        <Image
          src={propertyImage.image.url}
          objectFit="cover"
          options={{ w: 450, h: 200, c: 'scale' }}
        />
      </SelectableCard>
      <IconButton
        size="small"
        css={{
          position: 'absolute',
          top: 6,
          right: 6,
          color: (theme.vars ?? theme).palette.primary.main,
          backgroundColor: (theme.vars ?? theme).palette.background.paper,
          '&:hover': {
            backgroundColor: (theme.vars ?? theme).palette.background.paper,
          },
        }}
        onMouseDown={evt => {
          evt.stopPropagation();
          onDelete(propertyImage.id);
        }}
      >
        <Trash2Icon size={20} />
      </IconButton>
    </div>
  );
};

export default PropertyImageItem;
